import type { RouterOutputs } from '@/lib/trpc'
import type { ComparisonMode, TestConfiguration } from './tests-section'

type SavedTestConfig = RouterOutputs['admin']['questions']['saveTests']

/**
 * A `saveTests` result is the saved config plus `preservedStarterCode`, the
 * languages whose authored stub the save kept (LG-370). The form writes the
 * config back into its state and re-sends it on the next save, so the
 * per-save signal is split off here instead of riding along in the record.
 * Typed from the router so a server-side rename fails typecheck instead of
 * silently emptying the kept-stub note.
 */
export function splitSavedTestConfig(saved: SavedTestConfig): {
  testConfig: TestConfiguration
  preservedStarterCode: string[]
} {
  const { preservedStarterCode, comparisonMode, ...rest } = saved
  const testConfig: TestConfiguration = {
    ...rest,
    // The column is free text; the editor's union is the subset it writes.
    comparisonMode: comparisonMode as ComparisonMode,
  }
  return { testConfig, preservedStarterCode }
}
